import { ENDPOINTS } from "@ea/shared_types/next/endpoints";
import { createRequest } from "../requestCreator";

export const getPublicSettings = createRequest(ENDPOINTS.settingsInternalPublic, {
  public: true,
});
